// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promotion-card[data-v-73480bab] {\n  background: #1f2223;\n}\n\n.title[data-v-73480bab] {\n  color: #fff;\n}\n\n.text[data-v-73480bab] {\n  color: #d3d3d3;\n}", ""]);
// Exports
module.exports = exports;
